module.exports = __webpack_public_path__ + "static/media/buku-besar.55cd4786.svg";